import _ from 'lodash';
import moment from 'moment';
import { IAssessment, IBranch, IKpi, IUser } from 'src/Definitions';
import { IdentifierEntityDto } from 'src/generated_client';
import { IAssessmentFormValues } from './AssessmentDialog';

export default class AssessmentDialogLogic {
    private autoFilled = false;

    public save = (
        assessmentToSave: IAssessment,
        values: IAssessmentFormValues,
        users: IUser[],
        kpis: IKpi[],
        branches: IBranch[],
        saveAssessment: (assessment: IAssessment) => Promise<void>
    ) => {
        this.setObserversToSave(assessmentToSave, values, users);
        this.setKpisToSave(assessmentToSave, values, kpis);
        this.setComparisonBranchesToSave(assessmentToSave, values, branches);
        this.setTargetBranchToSave(assessmentToSave, values, branches);
        return saveAssessment(assessmentToSave);
    };

    private setObserversToSave(
        assessmentToSave: IAssessment,
        values: IAssessmentFormValues,
        users: IUser[]
    ) {
        assessmentToSave.observers = [];
        values.observerIds.forEach((observerId) => {
            const user = _.find(users, { id: observerId });
            if (user) {
                assessmentToSave.observers.push(
                    new IdentifierEntityDto({ name: user.name, id: user.id })
                );
            }
        });
    }

    private setKpisToSave(
        assessmentToSave: IAssessment,
        values: IAssessmentFormValues,
        kpis: IKpi[]
    ) {
        assessmentToSave.kpis = [];
        values.kpiIds.forEach((kpiId) => {
            const kpi = _.find(kpis, { id: kpiId });
            if (kpi) {
                assessmentToSave.kpis.push(new IdentifierEntityDto({ name: kpi.name, id: kpi.id }));
            }
        });
    }

    private setComparisonBranchesToSave(
        assessmentToSave: IAssessment,
        values: IAssessmentFormValues,
        branches: IBranch[]
    ) {
        assessmentToSave.comparisonBranches = [];
        values.comparisonBranchIds.forEach((comparisonBranchId) => {
            const comparisonBranch = _.find(branches, { id: comparisonBranchId });
            if (comparisonBranch) {
                assessmentToSave.comparisonBranches.push(
                    new IdentifierEntityDto({
                        id: comparisonBranch.id,
                        name: comparisonBranch.name,
                    })
                );
            }
        });
    }

    private setTargetBranchToSave(
        assessmentToSave: IAssessment,
        values: IAssessmentFormValues,
        branches: IBranch[]
    ) {
        const targetBranch = _.find(branches, { id: values.targetBranchId });
        if (targetBranch) {
            assessmentToSave.targetBranch = new IdentifierEntityDto();
            assessmentToSave.targetBranch.id = values.targetBranchId;
            assessmentToSave.targetBranch.name = targetBranch.name;
            assessmentToSave.regionName = targetBranch.region.name;
            assessmentToSave.targetBranchName = targetBranch.name;
        }
    }

    public getSelectedKpis(kpiIds: string[], kpis: IKpi[]) {
        return _.filter(kpis, (kpi) => _.some(kpiIds, (id) => id === kpi.id));
    }

    public findBranch(predicate: _.PartialDeep<IBranch>, branches: IBranch[]) {
        return _.find(branches, predicate);
    }

    public getValidTargetBranches(comparisonBranchIds: string[], branches: IBranch[]) {
        return _.filter(
            branches,
            (branch) => !_.some(comparisonBranchIds, (id) => branch.id === id)
        );
    }

    public getBranchesForIds(branchIds: string[], branches: IBranch[]) {
        return _.filter(branches, (branch) => _.some(branchIds, (id) => id === branch.id));
    }

    public areIdsSameAsInitialValues(initial: string[], current: string[]) {
        return _.xor(initial, current).length === 0;
    }

    public getValidComparisonBranches(targetBranchId: string, branches: IBranch[]) {
        return branches.filter((branch) => branch.id !== targetBranchId);
    }

    public setAssessmentName(
        values: IAssessmentFormValues,
        branches: IBranch[],
        setFieldValue: (name: string, value: any) => void
    ) {
        const targetBranch = this.findBranch({ id: values.targetBranchId }, branches);
        if (targetBranch && !this.autoFilled && !values.name) {
            this.autoFilled = true;
            setFieldValue(
                'name',
                `${moment(values.visitStartedOn).format('DD/MM/YYYY')} ${targetBranch.name}`
            );
        }
    }
}



// WEBPACK FOOTER //
// ./src/assessments/AssessmentDialogLogic.ts